import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { UserNoteOutput } from 'user/model/user-note.output';
import { UserNote } from 'user/note/user-note';

@Injectable({ providedIn: 'root' })
export class UserNoteConverterService {
	public userNoteAsEntity(output: UserNoteOutput): UserNote {
		if (!output) {
			return null;
		}

		return new UserNote(
			output.id,
			output.creationTimestamp,
			output.note,
			output.target.id,
			output.user.id,
			output.visibility
		);
	}

	public userNotesAsEntities(outputs: UserNoteOutput[]): UserNote[] {
		return reject(outputs, isNil).map((output) => this.userNoteAsEntity(output));
	}
}
